<template>
    <div v-if="isCoordinator">
        <content-with-side-menu @show-cookies="$emit('show-cookies')">
            <template #side-menu>
                <mq-layout mq="tablet+">
                    <management-side-menu class="is-hidden-mobile"/>
                </mq-layout>
            </template>
            <template #main-content>
                <mq-layout mq="mobile">
                    <dashboard-top-menu />
                </mq-layout>
                <router-view></router-view>
            </template>
        </content-with-side-menu>
    </div>
    <div v-else>
        <app-page-error />
    </div>
</template>

<script>
import AppPageError from '@/components/AppPageError';
import ManagementSideMenu from '@/components/ManagementSideMenu';
import DashboardTopMenu from '@/components/DashboardTopMenu';
import ContentWithSideMenu from '@/layouts/ContentWithSideMenu';
import { fetchItems} from '@/services/API';
export default {
    components: {
        AppPageError,
        DashboardTopMenu,
        ContentWithSideMenu,
        ManagementSideMenu,
    },
    data() {
        return {
            folders: [],
        };
    },
    mounted() {
        //this.$store.dispatch('fetchMyCommunities'); //force communities fetch to render side menu option
        //this.fetchFolders();
    },
    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        isCoordinator() {
            return this.$store.getters.hasSchool && this.$store.getters.canManageSchool;
        },
    },
    metaInfo() {
        return {
            title: 'Dashboard',
            titleTemplate: '%s - eduloc360',
        };
    },
    methods: {
        async fetchFolders() {
            const folders = await fetchItems('folder');
            this.folders = folders.data;
        },
        refreshFolders(){
            this.fetchFolders();
        }
    },
};
</script>

<style scoped lang="scss"></style>
